import CustomLayoutGeneralSettings from '@/components/CustomLayoutGeneralSettings';
import UpgradeTextWithTouchPoint from '@/components/UpgradeTextWithTouchPoint';
import { booleanToNumber, numberToBoolean } from '@/helpers';
import useUserPlan from '@/hooks/useUserPlan';
import settingsSlice, { dataSettingsSelector } from '@/redux/slice/settings.slice';
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CustomCard from '../customCard';
import RegularText from '../RegularText';
import Switch from '../Switch';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINT } from '@/constants/enum';

const RequiredValidPostCode = () => {
  const dispatch = useDispatch();
  const dataSettings = useSelector(dataSettingsSelector);
  const { isPlanLimited } = useUserPlan();
  const isMobile = useMediaQuery({ maxWidth: BREAKPOINT.XS });
  return (
    <CustomLayoutGeneralSettings
      isShowDivider
      notUseCard
      title="Zipcode validity"
      description={<p>Used for rules with zipcode condition</p>}
    >
      <CustomCard
        title={
          <span className={`d-flex align-center ${isPlanLimited ? 'text--gray' : ''}`} style={{ fontSize: '13px' }}>
            Require valid zipcode to add to cart
          </span>
        }
        titleContentRight={
          isPlanLimited ? (
            !isMobile ? (
              <div className="min-w-fit">
                <UpgradeTextWithTouchPoint isVisible={isPlanLimited} text="Pro" />
              </div>
            ) : undefined
          ) : (
            <Switch
              isActive={numberToBoolean(dataSettings.require_add_to_cart)}
              isLoading={isPlanLimited}
              onSwitch={(value) =>
                dispatch(
                  settingsSlice.actions.handleDataSettings({
                    ...dataSettings,
                    require_add_to_cart: booleanToNumber(value),
                  }),
                )
              }
            />
          )
        }
      >
        <div className="mt-8">
          <RegularText className={`${isPlanLimited ? 'text--gray' : ''}`}>
            For rules with zipcode display condition. When turned on, customers must enter a valid zipcode before adding products
            to cart. With invalid zipcodes, products cannot be added.
          </RegularText>
          {isMobile && (
            <div>
              <UpgradeTextWithTouchPoint isVisible={isPlanLimited} text="Pro" />
            </div>
          )}
        </div>
      </CustomCard>
    </CustomLayoutGeneralSettings>
  );
};

export default memo(RequiredValidPostCode);
